import { getApiErrorMessage } from './apiErrors'

const subscribers = new Set()

const emitToast = (toast) => {
  subscribers.forEach((listener) => listener(toast))
}

export const subscribeToasts = (listener) => {
  subscribers.add(listener)
  return () => subscribers.delete(listener)
}

export const notifyToast = ({ color = 'info', title = 'Сообщение', message, delay = 5000 }) => {
  if (!message) return

  emitToast({
    id: `${Date.now()}-${Math.random()}`,
    color,
    title,
    message,
    delay,
  })
}

export const notifySuccess = (message, title = 'Готово') =>
  notifyToast({ color: 'success', title, message })

export const notifyError = (message, title = 'Ошибка') =>
  notifyToast({ color: 'danger', title, message })

export const notifyApiError = (error, fallback) => notifyError(getApiErrorMessage(error, fallback))
